@import url('https://fonts.googleapis.com/css2?family=Noto+Color+Emoji&display=swap');
@import '@bbl-digital/snorre-v2/dist/style.css';

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  *,
  :before,
  :after {
    box-sizing: revert-layer;
  }
  .noto-color-emoji-regular {
    font-family: 'Noto Color Emoji', sans-serif;
    font-weight: 400;
    font-style: normal;
  }
}
